import { useMemo } from "react";

import FlexWrapper, { AlignItems } from "@gx/dls/containers/FlexWrapper";
import Text, { TextSize, TextVariant, TextWeight } from "@gx/dls/text/Text";
import { SourceResource } from "@gx/ts-contracts/services/source/resources/source_pb";

import { SourceCardBodyLoading } from "@/pages/sources/components/card/SourceCardLoading";

import { convertProtobufTimestampToDate, getTimeAgo } from "@/utils/datetimes";

interface SourceCardBodyProps {
  lastSyncedAt: SourceResource["updatedAt"];
  isLoading: boolean;
}

const SourceCardBody = ({ lastSyncedAt, isLoading }: SourceCardBodyProps) => {
  const lastSyncedAtDate = useMemo(() => {
    return lastSyncedAt ? convertProtobufTimestampToDate(lastSyncedAt) : null;
  }, [lastSyncedAt]);

  const lastSyncedAtFormatted = useMemo(() => {
    return lastSyncedAtDate ? getTimeAgo(lastSyncedAtDate) : "—";
  }, [lastSyncedAtDate]);

  if (isLoading) {
    return <SourceCardBodyLoading />;
  }

  return (
    <FlexWrapper gap={3} alignItems={AlignItems.CENTER}>
      {lastSyncedAtDate ? (
        <Text size={TextSize.BODY_SM} variant={TextVariant.TERTIARY}>
          Last synced
        </Text>
      ) : (
        <Text size={TextSize.BODY_SM} variant={TextVariant.TERTIARY}>
          No syncs yet
        </Text>
      )}
      {lastSyncedAtDate && (
        <Text size={TextSize.BODY_SM} weight={TextWeight.MEDIUM} variant={TextVariant.TERTIARY}>
          {lastSyncedAtFormatted.toLowerCase()}
        </Text>
      )}
    </FlexWrapper>
  );
};

export default SourceCardBody;
